// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import LocaleSwitcherController from "./locale_switcher_controller"
application.register("locale-switcher", LocaleSwitcherController)

import CheckPollController from "./check_poll_controller"
application.register("check-poll", CheckPollController)

import UrlInputController from "./url_input_controller"
application.register("url-input", UrlInputController)
